import Weather from "./weather";
import AttendanceOverview from "./attendance-overview";
import InsightsOverview from "./insights-overview";
import { useEffect, useState } from "react";
import AtriumApi from "api";
// import Select from "components/fields/Select";
// import Select from "components/fields/Select";

const Dashboard = () => {
  const [tab, setTab] = useState("attendance");
  const [campuses, setCampuses] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);
  const [selectedCampusId, setSelectedCampusId] = useState("all");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAllCampuses = async () => {
      try {
        const response = await AtriumApi.get("/v2/campuses/allCampuses");
        if (response) {
          setCampuses(response?.data?.data?.campuses?.data);
        }
      } catch (error) {
        console.log("fetching all campuses error", error);
      }
    };
    fetchAllCampuses();
  }, []);

  useEffect(() => {
    function buildQueryString() {
      if (selectedCampusId && selectedCampusId !== "all") {
        return `campusId=${selectedCampusId}`;
      }
      return "";
    }

    const fetchDashboard = async () => {
      setLoading(true);
      try {
        const query = buildQueryString();
        const response = await AtriumApi.get(
          `/v1/dashboard${query ? `?${query}` : ""}`
        );
        if (response) {
          setLoading(false);
          setDashboardData(response?.data?.data);
        }
      } catch (error) {
        setLoading(false);
        console.log("fetching dashboard error", error);
      }
    };
    fetchDashboard();
  }, [selectedCampusId]);

  return (
    <div className="mt-3">
      {campuses?.length > 0 ? (
        <Weather />
      ) : (
        <div className="text-center mt-5">No campus found</div>
      )}

      <div className="mt-5 flex items-center p-4 flex-wrap gap-5">
        <div className="flex-1">
          <h2 className="font-bold text-lg">Overview</h2>
          <div className="flex">
            <p className="flex-none text-gray-700 text-base font-medium">
              Overview of activity and engagement
            </p>
            {/* <p className="flex-none text-gray-700 text-base font-medium">Overview of activity and engagement for</p>&nbsp; */}
            <select
              value={selectedCampusId === "all" ? "all" : selectedCampusId?.id}
              onChange={(e) => {
                const campus = campuses?.find(
                  (c) => c?.name === e.target.value
                );
                setSelectedCampusId(campus ? campus?.id : null);
              }}
              className="flex-none bg-[transparent] rounded-xl outline-none text-base "
            >
              <option value="all campuses">All campuses</option>
              {campuses?.length > 0 ? (
                campuses?.map((campus) => (
                  <option key={campus?.id} value={campus?.name}>
                    {campus?.name}
                  </option>
                ))
              ) : (
                <option disabled>No campus found</option>
              )}
            </select>
            <div className="flex-1"></div>
          </div>
        </div>
        {/* <div className="flex gap-3 flex-none">
          <form class="max-w-sm mx-auto">
            <select
              id="countries"
              class="bg-gray-50 border border-gray-300 text-gray-700 outline-none text-sm rounded-lg block w-full p-2.5 \ dark:border-gray-600 dark:placeholder-gray-400 dark:text-white "
            >
              <option selected>All Roles</option>
              <option value="US">United States</option>
              <option value="CA">Canada</option>
              <option value="FR">France</option>
              <option value="DE">Germany</option>
            </select>
          </form>
          <form class="max-w-sm mx-auto">
            <select
              id="countries"
              class="bg-gray-50 border border-gray-300 text-gray-700 outline-none text-sm rounded-lg block w-full p-2.5 \ dark:border-gray-600 dark:placeholder-gray-400 dark:text-white "
            >
              <option selected>All distance</option>
              <option value="US">United States</option>
              <option value="CA">Canada</option>
              <option value="FR">France</option>
              <option value="DE">Germany</option>
            </select>
          </form>
        </div> */}
      </div>

      <div className="flex mt-5 p-1 bg-[#F4F7FE] dark:bg-navy-800 rounded-[20px]">
        <button
          className={
            "rounded-2xl pl-4 pr-4 pt-2 pb-2" +
            (tab === "attendance"
              ? " bg-white dark:bg-navy-700 font-bold"
              : " bg-[transparent]")
          }
          onClick={() => setTab("attendance")}
        >
          Attendance
        </button>
        {/* <button
          className={
            "rounded-2xl pl-4 pr-4 pt-2 pb-2" +
            (tab === "insights"
              ? " bg-white dark:bg-navy-700 font-bold"
              : " bg-[transparent]")
          }
          onClick={() => setTab("insights")}
        >
          Insights
        </button> */}
      </div>

      {tab === "attendance" && (
        <AttendanceOverview
          dashboardData={dashboardData}
          selectedCampusId={selectedCampusId}
          loading={loading}
        />
      )}
      {tab === "insights" && <InsightsOverview />}
    </div>
  );
};

export default Dashboard;
